import { render, staticRenderFns } from "./SecurityTabAPI.vue?vue&type=template&id=8d188238"
import script from "./SecurityTabAPI.vue?vue&type=script&lang=js"
export * from "./SecurityTabAPI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports